import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
    Typography,
} from '@material-ui/core';
import DebouncedTextField from '@commonClient2/components/DebouncedTextField';
import { UPDATE_SETUP } from '../../../store/setup';

const InputTitle = (props) => (
    <Typography
        component="p"
        className="input-label"
        {...props}
    >
        {props.children}
    </Typography>
);

const InputDisclaimer = (props) => (
    <p {...props}>
        <small className="input-disclaimer">
            {props.children}
        </small>
    </p>
);

/**
 * @param {{
 *  stepIndex: number
 *  validationErrors: {[Key: string] : boolean}
 *  errorRef: import('react').MutableRefObject<HTMLInputElement>
 * }} props
 */
function InformationSection({ stepIndex, validationErrors, errorRef }) {
    const dispatch = useDispatch();
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'admin.setupEdit.informationStep' });

    /** @type {ShiftBidding.AdminStore} */
    // @ts-ignore
    const { adminSetup } = useSelector((state) => state);
    const {
        name,
        description,
    } = adminSetup;

    /**
     * @param {string} target
     * @param {string} value
     */
    const updateSetupStore = (target, value) => {
        dispatch({
            type: UPDATE_SETUP,
            payload: {
                [target]: value,
            },
        });
    };

    return (
        <Card className="card">
            <CardHeader
                ref={errorRef}
                className="card--header"
                gutterbottom
                avatar={<Avatar className="avatar">{stepIndex}</Avatar>}
                title={t('title')}
            />
            <CardContent>
                <div>
                    <InputTitle>{t('nameInput.label')}</InputTitle>
                    <DebouncedTextField
                        // @ts-ignore
                        error={validationErrors.name}
                        value={name}
                        onChange={(event) => updateSetupStore('name', event.target.value)}
                        inputProps={{ maxLength: 50 }}
                        placeholder={t('nameInput.placeholder')}
                        variant="outlined"
                    />
                    {
                        validationErrors.name && (
                            <span style={{ color: 'red' }}>{validationErrors.nameErrorMessage}</span>)
                    }
                    <InputDisclaimer>{t('nameInput.disclaimer')}</InputDisclaimer>
                </div>

                <div>
                    <InputTitle>{t('descriptionInput.label')}</InputTitle>
                    <DebouncedTextField
                        // @ts-ignore
                        value={description}
                        onChange={(event) => updateSetupStore('description', event.target.value)}
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 250 }}
                        placeholder={t('descriptionInput.placeholder')}
                        variant="outlined"
                    />
                    <InputDisclaimer>{t('descriptionInput.disclaimer')}</InputDisclaimer>
                </div>
            </CardContent>
        </Card>

    );
}

export default InformationSection;
